import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../api/axios";
import ENDPOINTS from "../../../api/endpoints";

/* ---------------- CREATE ---------------- */
export const createCycle = createAsyncThunk(
  "cycle/create",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await api.post(ENDPOINTS.CYCLES.BASE, payload);
      return data;
    } catch (err) {
      return rejectWithValue(
        err?.response?.data?.message || "Erreur création cycle"
      );
    }
  }
);

/* ---------------- LIST ---------------- */
export const fetchCyclesByUser = createAsyncThunk(
  "cycle/fetchByUser",
  async (userId, { rejectWithValue }) => {
    try {
      const { data } = await api.get(ENDPOINTS.CYCLES.BY_USER(userId));
      return data;
    } catch (err) {
      return rejectWithValue(
        err?.response?.data?.message || "Erreur récupération cycles"
      );
    }
  }
);

/* ---------------- PREDICTIONS ---------------- */
export const fetchPredictions = createAsyncThunk(
  "cycle/fetchPredictions",
  async (userId, { rejectWithValue }) => {
    try {
      const { data } = await api.get(
        ENDPOINTS.CYCLES.PREDICTIONS(userId)
      );
      return data;
    } catch (err) {
      return rejectWithValue(
        err?.response?.data?.message || "Erreur prédictions"
      );
    }
  }
);

/* ---------------- FERTILITY WINDOW ---------------- */
export const fetchFertilityWindow = createAsyncThunk(
  "cycle/fetchFertilityWindow",
  async (userId, { rejectWithValue }) => {
    try {
      const { data } = await api.get(
        ENDPOINTS.CYCLES.FERTILITY_WINDOW(userId)
      );
      return data;
    } catch (err) {
      return rejectWithValue(
        err?.response?.data?.message || "Erreur fenêtre fertile"
      );
    }
  }
);

/* ---------------- SUMMARY ---------------- */
export const fetchCycleSummary = createAsyncThunk(
  "cycle/fetchSummary",
  async (userId, { rejectWithValue }) => {
    try {
      const { data } = await api.get(
        ENDPOINTS.CYCLES.SUMMARY(userId)
      );
      return data;
    } catch (err) {
      return rejectWithValue(
        err?.response?.data?.message || "Erreur résumé cycle"
      );
    }
  }
);
